import { gsap } from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(TextPlugin, ScrollTrigger);

const $body = $('body');
const footer = document.querySelector('.site-footer__main');
const allTitles = document.querySelectorAll('.site-footer__title');
const visibleTitles = Array.from(allTitles).filter(el => el.offsetWidth > 0); // desktop or mobile can have hidden elements, we dont want delays

const titleData = visibleTitles.map(title => {
    const originalText = title.innerText;
    title.innerHTML = '<span class="cursor"></span>';
    return { element: title, text: originalText };
});

const tl = gsap.timeline({
    scrollTrigger: {
        trigger: footer,
        start: 'top 50%',
        //markers: true,
        toggleActions: 'play none none none',
    }
});

tl.to(visibleTitles, {
    text: (i) => titleData[i].text,
    duration: .5,
    stagger: .5,
    ease: 'none',
    delay: .25
});

window.addEventListener('load', () => {
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 200);
});

const dropDownIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.51 103.52"><defs><style>.cls-1 { fill: #fb7d0f; }</style></defs><polygon class="cls-1" points="51.83 51.69 0 103.52 45.82 103.52 97.51 51.83 97.51 51.83 45.67 0 .14 0 51.83 51.69"/></svg>';

$('<button type="button" class="sub-menu-toggle" title="Sub-menu tonen/verbergen"><span class="sub-menu-toggle__icon">'+dropDownIcon+'</span></button>').insertBefore('.site-footer__nav .menu-item-has-children .sub-menu');

// toggle sub-menus
$body.on('click', '.site-footer .sub-menu-toggle', function () {
    const $toggle = $(this);

    if ($toggle.attr('data-state') === 'toggled') {
        $toggle.attr('data-state', '');
    } else {
        $toggle.attr('data-state', 'toggled');
    }

    $toggle.blur();
});
